import { render, staticRenderFns } from "./ExternalOrders.vue?vue&type=template&id=feff1212&"
import script from "./ExternalOrders.vue?vue&type=script&lang=js&"
export * from "./ExternalOrders.vue?vue&type=script&lang=js&"
import style0 from "./ExternalOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports